import {i18n} from '@/plugins/i18n'
import {
    contractStatusStr,
    contractStatusVariant,
    templateStatusStr,
    templateStatusVariant
} from '@/constants/onlineContract'
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'contract_title',
        title: i18n.t('online_contract.title'),
        sortable: false,
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'user_full_name',
        title: i18n.t('online_contract.user_full_name'),
        sortable: false,
        width: 120,
        template: (row) => '<a href="/users/' + row.user_id + '/details">'+row.user_full_name+'</a>',
        textAlign: 'center',
    },
    {
        field: 'price',
        title: i18n.t('label.online_contract.price'),
        sortable: false,
        textAlign: 'center',
        width: 90
    },
    {
        field: 'status',
        sortable: true,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status = contractStatusStr.get(row.status)
            let variant = 'badge-' + contractStatusVariant(row.status)

            return '<div class="badge ' + variant + ' text-white">' + status + '</div>'
        },
        width: 80
    },
]